import { requestResourceByName, useActivity, useScopedSelector } from 'ia-react-core';
import React, { FC, ReactNode } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ResourcesLoader, Link } from 'omni-package-react-core';
import { useDispatch } from 'react-redux';
import { ReactComponent as BackIcon } from '../../assets/breadcrumb-back.svg';
import MessageDetailsLoader from './DetailsLoader';
import { MessageDetailsPageState } from '../../interfaces/MessageDetailsPageState';
import Header from './Header';
import { StyledDiv, StyledEmphasisBlock } from './MessageDetailsPage.styles';
import Constants from '../../Constants';
import MessagingSummaryResource from '../../components/MessagingSummaryResource';
import { MessageDetailsResourceInfo } from './DetailsLoader/DetailsLoader';

export interface MessageDetailsPageProps {
  children?: ReactNode;
}

const twentyNineMinutes = 1740000;

const MessageDetailsPage: FC<MessageDetailsPageProps> = ({ children }) => {
  const { t } = useTranslation('MessageDetailsPage');
  const { messageId } = useParams<{ messageId: string }>();
  const { search } = useLocation();
  const messageSource = new URLSearchParams(search).get('messageSource');
  const params = new URLSearchParams(window.location.search);
  params.set(`messagesResource${messageSource}`, params.get('page'));
  params.delete('page');

  const messageDetails = useScopedSelector((state: MessageDetailsPageState) => state?.messageDetails);

  const dispatch = useDispatch();
  useActivity(() => {
    dispatch(requestResourceByName(MessageDetailsResourceInfo.name));
  }, [], { frequency: twentyNineMinutes, strategy: 'leading' });

  return (
    <ResourcesLoader reloadEveryTime validateAuthorization validateAvailability>
      <ResourcesLoader.Resources>
        <MessagingSummaryResource />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <StyledDiv>
          <Link LeftIcon={BackIcon} redirectTo={`${Constants.BasePagePath}?${params}`}>{t('breadCrumbMessages')}</Link>
        </StyledDiv>
        <StyledEmphasisBlock>
          <Header mailSubject={messageDetails?.data.subjectDescription ?? ''} messageSource={messageSource} />
          <MessageDetailsLoader messageId={messageId} messageSource={messageSource}>
            {children}
          </MessageDetailsLoader>
        </StyledEmphasisBlock>
      </ResourcesLoader.Content>
    </ResourcesLoader>
  );
};

export default MessageDetailsPage;
